"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmeraldListCheckboxPosition = void 0;
var EmeraldListCheckboxPosition;
(function (EmeraldListCheckboxPosition) {
    EmeraldListCheckboxPosition["LEADING"] = "leading";
    EmeraldListCheckboxPosition["TRAILING"] = "trailing";
})(EmeraldListCheckboxPosition || (exports.EmeraldListCheckboxPosition = EmeraldListCheckboxPosition = {}));
//# sourceMappingURL=list-checkbox.position.js.map